import ReceivedDocumentCrud from "../components/received-document/ReceivedDocumentCrud";

const ReceivedDocumentsPage = () => {
  return <ReceivedDocumentCrud />;
};

export default ReceivedDocumentsPage;
